import fetchAllCropsV2, { FETCH_CROPS } from '@dehaat/kisan-app-bl/api/fetchAllCropsV2';
import postFarmTag from '@dehaat/kisan-app-bl/api/postFarmV3Tag';
import Crop, { CropsWithCategoryProps } from '@dehaat/kisan-app-bl/models/CropV2';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AuthContext } from '@/context/AuthProvider';
import { UserContext } from '@/context/UserProvider';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import { LocationType } from '@/utils/google';
import CropSelectionModal from '../CropSelectionModal';
import TakeFarmPhoto from '../geoTag/TakeFarmPhoto';
import LoginScreen from '../login/LoginScreen';
interface satelliteMonitoringType {
  farmName: string;
  image: string;
  crop?: Crop;
  location?: LocationType;
}
interface Props {
  location?: LocationType;
  farmImage?: {
    file: Blob;
    filepath: string;
  };
  onContinue: (id: number) => void;
  onBackClick: VoidFunction;
}
const FarmTag = ({
  farmImage,
  onContinue,
  onBackClick,
  location
}: Props) => {
  const {
    t
  } = useTranslation('satellite');
  const [activeStep, setActiveStep] = useState(1);
  const [satelliteMonitoringData, setSatelliteMonitoringData] = useState<satelliteMonitoringType>({
    farmName: '',
    image: ''
  });
  const [userCrops, setUserCrops] = useState<CropsWithCategoryProps[]>([]);
  const [isCropsLoading, setIsCropsLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const {
    user
  } = useContext(UserContext);
  const {
    locale
  } = useRouter();
  const {
    isAuthenticated
  } = useContext(AuthContext);
  const {
    trackCustomEvent
  } = useTriggerEvents();
  useEffect(() => {
    const getAllCrops = async () => {
      if (userCrops.length === 0) {
        if (isAuthenticated) {
          setIsCropsLoading(true);
          try {
            const allCrops = await fetchAllCropsV2(locale, FETCH_CROPS.ALL_CROPS);
            if (allCrops && allCrops.length > 0) {
              setUserCrops(allCrops);
            }
          } catch {
            //TODO: Handle Error
          } finally {
            setIsCropsLoading(false);
          }
        }
      }
    };
    if (activeStep == 1) getAllCrops();
  }, [isAuthenticated, userCrops.length, locale, activeStep]);
  const postDetails = useCallback(async () => {
    const {
      farmName,
      image,
      crop,
      location
    } = satelliteMonitoringData;
    try {
      if (crop && location) {
        const res = await postFarmTag({
          crop: crop.id,
          name: farmName,
          source: 'web',
          photo: image,
          plot_centroid_coordinates: {
            type: 'Point',
            coordinates: [Number(location.longitude), Number(location.latitude)]
          },
          plot_centroid_accuracy: location.accuracy
        });
        if (res) {
          onContinue(res.id);
        }
      }
    } catch {}
  }, [onContinue, satelliteMonitoringData]);
  useEffect(() => {
    if (satelliteMonitoringData?.crop?.id && satelliteMonitoringData.location) {
      postDetails();
    }
  }, [postDetails, satelliteMonitoringData?.crop, satelliteMonitoringData.location]);
  useEffect(() => {
    if (!isAuthenticated) {
      setShowLogin(true);
    }
  }, [activeStep, isAuthenticated]);
  const handleCropAdded = (crops: Crop[]) => {
    trackCustomEvent(CustomEventTypes.SATELLITE_CROP_ADDED, JSON.stringify({
      FarmerName: user?.full_name,
      FarmerNumber: user?.phone_number,
      cropName: crops[0].name,
      cropId: crops[0].id,
      source: 'Satellite Tagging'
    }));
    setSatelliteMonitoringData({
      ...satelliteMonitoringData,
      crop: crops[0]
    });
  };
  return <>
      {showLogin && <LoginScreen isPopup onBack={() => setActiveStep(0)} onLogin={() => {
      setShowLogin(false);
    }} />}
      {activeStep == 1 && !showLogin && <TakeFarmPhoto onContinue={(farmName, image, location) => {
      setSatelliteMonitoringData({
        farmName,
        image,
        location
      });
      setActiveStep(activeStep + 1);
    }} onBackClick={() => {
      setActiveStep(1);
      onBackClick();
    }} farmImage={farmImage!} location={location!} />}
      <CropSelectionModal isLoading={isCropsLoading} show={activeStep == 2} currentCrops={[]} allCrops={userCrops} onContinue={handleCropAdded} heading={t('select_farm_crop')} onBack={() => setActiveStep(1)} isSingleSelect data-sentry-element="CropSelectionModal" data-sentry-source-file="FarmTag.tsx" />
    </>;
};
export default FarmTag;